import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService, PRODUCT_NORMALIZER, } from '@spartacus/core'
import { HttpClient } from '@angular/common/http'
import { of } from 'rxjs'
import { MbProductByOriginalCodeAdapter } from '../connectors'
import { catchError } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class MbOccProductByOriginalCodeAdapter implements MbProductByOriginalCodeAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  loadProductByOriginalCode (code: string) {
    return this.http.get(this.getEndpoint(code)).pipe(
      this.converter.pipeable(PRODUCT_NORMALIZER),
      catchError(() => of(undefined))
    )
  }

  protected getEndpoint (code: string) {
    return this.occEndpoints.buildUrl('productByOriginalCode', {
      urlParams: { productCode: code },
    })
  }
}
